import { defineComponent as _defineComponent } from 'vue'
import MyProjectDetails from '@/views/my-projects/components/MyProjectDetails.vue';
import BCXPaginatedContent from '@/components/molecules/BCXPaginatedContent.vue';
import ProjectListItem from '@/views/project-forum/components/ProjectListItem.vue';
import BCXMarkdown from '@/components/molecules/BCXMarkdown.vue';
import BCXConfirm from '@/components/molecules/BCXConfirm.vue';
import IconCleanup from '@/components/svg/cleanup.svg?inline';
import {
  useArrayFilter, useSorted, useToggle
} from '@vueuse/core';
import useResponsiveness from '@/mixins/useResponsiveness';
import {
  RecommendationInitiatedBy, RECOMMENDATIONS_EVENT_REFRESH
} from '@/models/Recommendations';
import {
  computed, onMounted, PropType, ref, watch
} from 'vue';
import useUser from '@/mixins/useUser';
import useRecommendationState from '@/state/recommendationsState';
import useBCXConfirm from '@/mixins/useBCXConfirm';
import RecommendationService from '@/services/RecommendationService';
import { PromisePool } from '@supercharge/promise-pool';
import MyProjectsSectionHeader from '@/views/my-projects/components/MyProjectsSectionHeader.vue';
import { useMyProjects } from '@/views/my-projects/composables/useMyProjects';
import BCXFilterButtons from '@/components/BCXFilterButtons.vue';
import BCXButton from '@/components/molecules/BCXButton.vue';
import useSparseLocalStorage from '@/mixins/useSparseLocalStorage';


export default /*#__PURE__*/_defineComponent({
  __name: 'MyProjectsWatchlist',
  props: {
  type: {
    type: String as PropType<'made' | 'watched'>,
    default: 'made'
  }
},
  setup(__props) {

const props = __props;

const { isGuest } = useUser('self');
const { recommendationsEventBus } = useRecommendationState();
const { loadMyProjects, myProjects } = useMyProjects();

const [isCleanup, toggleIsCleanup] = useToggle();
const { isMobileWidth } = useResponsiveness();
const checkedProjectIds = ref([]);
const { tUserFallback: t } = useUser('self');
const { onConfirm, showConfirm, ask } = useBCXConfirm();

const isExpanded = useSparseLocalStorage('watchlist-expanded', true);

const filterValue = ref(['ACTIVE']);
const filterItems = computed(() => ['ACTIVE', 'CLOSED'].map((state) => {
  const label = `${t(`my-projects.overview.filters.${state}`)}`;
  return {
    label,
    value: state
  };
}));



recommendationsEventBus.on((event) => {
  if (event === RECOMMENDATIONS_EVENT_REFRESH) loadMyProjects();
});

const filteredProjects = useArrayFilter(myProjects, (project) => {
  if (!filterValue.value.includes(project.project.status)) return false;
  const isCreated = project.initiatedBy === RecommendationInitiatedBy.Creation;
  return (props.type === 'made') ? isCreated : !isCreated;
});

const watchList = useSorted(filteredProjects, (a, b) => `${b.project.latestAddedReply || b.createdTimestamp}`.localeCompare(
  `${a.project.latestAddedReply || a.createdTimestamp}`
));

const removeRecommendation = async (userProjectId:string) => {
  if (!await ask()) return;
  await RecommendationService.deleteMyProject(userProjectId);
  await loadMyProjects();
};

const cleanup = async () => {
  await PromisePool.for(checkedProjectIds.value)
    .withConcurrency(20)
    .process(async (projectId) => {
      await RecommendationService.deleteMyProject(projectId);
    });
  isCleanup.value = false;
  await loadMyProjects();
};

// clear selected id when entereing cleanup mode:
watch(isCleanup, (is) => {
  if (is) checkedProjectIds.value = [];
});

const confirmText = computed(() => t('my-projects.watchlist.confirmDelete.text', { count: checkedProjectIds.value.length }).toString());

const emptyText = computed(() => {
  if (myProjects.value.length) {
    return t('my-projects.watchlist.emptyWatchlistFiltered_USERTYPE', { status: filterItems.value.find((item) => filterValue.value.includes(item.value))?.label ?? '-' });
  }
  return props.type === 'watched' ? t('my-projects.watchlist.emptyWatchlist_USERTYPE') : t('my-projects.watchlist.emptyOwnProjectslist_USERTYPE');
});

// When there are only closed projects available, set filter to show them instead:
onMounted(() => {
  if (!filteredProjects.value.length && myProjects.value.length) {
    filterValue.value = ['CLOSED'];
  }
});


return { __sfc: true,isGuest, recommendationsEventBus, loadMyProjects, myProjects, isCleanup, toggleIsCleanup, isMobileWidth, checkedProjectIds, t, onConfirm, showConfirm, ask, isExpanded, filterValue, filterItems, props, filteredProjects, watchList, removeRecommendation, cleanup, confirmText, emptyText, MyProjectDetails, BCXPaginatedContent, ProjectListItem, BCXMarkdown, BCXConfirm, IconCleanup, MyProjectsSectionHeader, BCXFilterButtons, BCXButton }
}

})